import type { PokerSpinAndGoState } from './types';

export const defaultState: PokerSpinAndGoState = {
  isLoading: false,
  hasPreloaded: false,
  hasError: false,
  games: [],
  watchGames: {
    hallOfFame: [],
    recentBigWins: [],
    bestLiveNow: [],
    userImageMap: {}
  },
  tickerMessage: null
};
